import { $isTableCellNode, $isTableNode, $isTableRowNode } from "@lexical/table";
import { $isRootNode, type LexicalNode } from "lexical";
import { $isDataTableCellNode } from "../nodes/data-table-cell-node";
import { $isDataTableNode, DataTableNode } from "../nodes/data-table-node";

export const $isInTableNode = (node: LexicalNode): boolean => {
  if ($isTableNode(node) || $isTableRowNode(node) || $isTableCellNode(node)) {
    return true;
  }

  const parent = node.getParent();
  if (!parent || $isRootNode(parent)) return false;

  return $isInTableNode(parent);
};

export const $isInDataTableNode = (node: LexicalNode): boolean => {
  if ($isDataTableNode(node) || $isDataTableCellNode(node)) {
    return true;
  }

  const parent = node.getParent();
  if (!parent || $isRootNode(parent)) return false;

  return $isInDataTableNode(parent);
};

export const findDataTableNode = (node: LexicalNode): DataTableNode | null => {
  if ($isDataTableNode(node)) {
    return node;
  }

  const parent = node.getParent();
  if (!parent || $isRootNode(parent)) return null;

  return findDataTableNode(parent);
};
